import React from 'react';

import clsx from 'clsx';
import { useParams } from 'next/navigation';

import styles from './styles.module.css';

import { ShopDropCountdown } from '@/app/[locale]/shop/[username]/(shop)/components/ShopDropCountdown';
import {
  isDropCountdownPeriod,
  isDropExpired,
} from '@/modules/shop/helpers/dropTiming';
import { useShopByUsername } from '@/modules/shop/hooks/useShopByUsername';

type Props = {
  dropDate: string;
  showUntil: string;
  firstName: string;
  timeZoneName: string;
  className?: string;
};

export function ShopDrop({
  dropDate,
  showUntil,
  firstName,
  timeZoneName,
  className,
}: Props) {
  const { username } = useParams<{ username: string; locale: string }>();
  const { data: sellerData } = useShopByUsername();
  const sellerId = sellerData?.data?.id;

  if (isDropExpired(showUntil) || !sellerId) {
    return null;
  }

  return (
    <section className={clsx(styles.wrapper, className)}>
      <ShopDropCountdown
        dropDate={dropDate}
        firstName={firstName}
        timeZoneName={timeZoneName}
        isPostLaunch={!isDropCountdownPeriod(dropDate)}
        sellerId={sellerId}
        username={username}
      />
    </section>
  );
}
